import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {WishlistMetaService_GetPageMetaDataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/meta/service.grpc.lazy';
import {Head} from '@aboutyou/head-elements';
import React, {Fragment} from 'react';

import {Page} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/page.types';
import {TrackContentPageView} from '@aboutyou/tracking';
import {
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';

export const WishlistPageMeta = () => {
  return (
    <DataFetcher
      request={useGetWishlistPageMeta()}
      Error={() => null}
      View={View}
    />
  );
};

function useGetWishlistPageMeta() {
  return useGrpcRequest(WishlistMetaService_GetPageMetaDataLazy, {});
}

const View = ({meta}: {meta: Page}) => {
  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <Fragment>
      <TrackContentPageView pageTitle={seoData.title} />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </Fragment>
  );
};
